// canales.js
//
// Tabla ÚNICA de «Cómo nos conociste» (#1738 R17, R19): el alta, la pantalla de lo que falta y la
// ficha 360 del admin leen de acá. El orden es el de la pantalla. `anuncio_meta` es el anuncio
// pagado (solo Meta: Instagram o Facebook) y va separado del contenido orgánico, para saber dónde
// poner plata. Los `value` ya guardados (`instagram`, `colega`, `google`, `ia`, `hospital`...) se
// conservan: solo cambian las etiquetas y se suma `anuncio_meta`.
//
// PAR EN EL BACKEND: `backend/app/user_api/onboarding_completo.py` (CANALES). Son dos repos: si
// cambia un valor allá, cambia acá. Cubre R17 y R19 — .claude/specs/1738-etapa-alta/

export const CANALES_OPCIONES = [
  { value: "anuncio_meta", label: "Anuncio en Instagram o Facebook" },
  { value: "instagram", label: "Instagram (un post o reel)" },
  { value: "tiktok", label: "TikTok" },
  { value: "colega", label: "Un colega" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "google", label: "Busqué en Google" },
  { value: "ia", label: "Una IA (ChatGPT…)" },
  { value: "congreso", label: "Congreso o charla" },
  { value: "hospital", label: "Mi hospital o universidad" },
  { value: "otro", label: "Otro" },
];

export const CANAL_LABELS = Object.fromEntries(CANALES_OPCIONES.map((o) => [o.value, o.label]));

// Etiqueta para el admin: «Otro» muestra lo que escribió; un valor desconocido se muestra tal cual.
export const etiquetaCanal = (valor, otro = "") => {
  if (!valor) return "";
  if (valor === "otro" && otro) return otro;
  return CANAL_LABELS[valor] || valor;
};
